
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/foerderung/workshops",
      function () {
        return require("private-next-pages/foerderung/workshops/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/foerderung/workshops"])
      });
    }
  